module.exports = __webpack_public_path__ + "img/ke.358270df.jpg";